import { useMemo } from 'react';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { getBankCardStackSize } from './getBankCardStackSize.ts';
import { CardDataController } from '@colonist/game-card-types';
import { useBankCardState } from './useBankCardState.ts';
export const useBankCardStackSizes = ()=>{
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const bankCardState = useBankCardState();
    return useMemo(()=>{
        const stackSizes = {};
        for (const [cardEnum, count] of Object.entries(bankCardState)){
            const card = CardDataController.getCardDataForCard(Number(cardEnum));
            if (card == undefined) continue;
            const stackSize = getBankCardStackSize(modeSetting, card.cardTypeEnum, count);
            stackSizes[card.cardEnum] = stackSize;
        }
        return stackSizes;
    }, [
        bankCardState,
        modeSetting
    ]);
};
